module.exports = __webpack_public_path__ + "img/angle-double-up.17dbe9af.svg";